// 获取产品升级方案的商品套餐
// http://api.umucdn.cn/project/216/interface/api/3004
import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';
import { PLAN_TYPE, IPlanPackageGoods } from '@umu/umu-types';

export interface IInput {
    plan_id: PLAN_TYPE;
}

export interface IOutput {
    package_list: IPlanPackageGoods[];
}

// tslint:disable-next-line:max-line-length
export const getPlanPackages = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.GET_PLAN_PACKAGE, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};

export const getPlanPackagesSync = fetchDataSync(getPlanPackages);
